module.exports = __webpack_public_path__ + "static/media/Mechanic.a08a8aff.jpg";